import { render, staticRenderFns } from "./toolbarItems.vue?vue&type=template&id=1127bb38&"
import script from "./toolbarItems.vue?vue&type=script&lang=js&"
export * from "./toolbarItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports